import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { getAllCountries, getCountry, getTimezone, getTimezonesForCountry } from 'countries-and-timezones';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-country-timezone',
  templateUrl: './country-timezone.component.html',
  styleUrls: ['./country-timezone.component.scss'],
})
export class CountryTimezoneComponent implements OnInit {

  alertOptions = {
    cssClass: 'wide-alert'
  }

  @Input() country: string | undefined //code eg AU
  @Input() timezone: string | undefined

  @ViewChild('timezoneItem', { static: false }) timezoneItem

  deviceTimezone = DateTime.now().zoneName || 'Australia/Sydney'
  countries: {
    code: string,
    name: string
  }[] = []
  timezones: string[] = []
  countryForm: FormGroup

  constructor(private formBuilder: FormBuilder) {
    this.countryForm = this.formBuilder.group({
      country: [''],
      timezone: [''],
    })
    // build country list based on device's timezone
    this.buildCountryList(this.deviceTimezone)
  }

  getCountry(): string {
    return this.countryForm.get('country').value
  }

  getTimezone(): string {
    return this.countryForm.get('timezone').value
  }

  ngOnInit() {
    console.debug('CountryTimezoneComponent onInit', this.country, this.timezone)
    this.refresh()
  }

  ngOnChanges() {
    console.debug('CountryTimezoneComponent onChanges', this.country, this.timezone)
    this.refresh()
  }

  refresh() {
    // default country to the first in the list, which should be based on the device timezone
    const country = this.country || this.countries[0].code
    this.buildTimezoneList(country)
    const timezone = this.timezone || this.deviceTimezone
    console.debug('CountryTimezoneComponent refresh', { country, timezone })
    this.countryForm.setValue({ country, timezone })
  }

  // build a list of countries. For convenience, add entries at the start
  // based on the device's timezone
  buildCountryList(timezone) {
    console.debug('buildCountryList', timezone)
    const timezoneObj = getTimezone(timezone)
    if (timezoneObj) {
      for (const code of timezoneObj.countries) {
        const countryObj = getCountry(code)
        this.countries.push({
          code: code,
          name: countryObj.name
        })
        this.countries.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
      }
      // add a separator
      this.countries.push({
        code: null, //disables the select item, see html
        name: '---------------'
      })
    }
    // now add all countries
    const allCountries: {code: string, name: string}[] = []
    for (const [code, country] of Object.entries(getAllCountries())) {
      allCountries.push({
        code: code,
        name: country.name
      })
    }
    allCountries.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0)
    this.countries = this.countries.concat(allCountries)
  }

  buildTimezoneList(country: string) {
    this.timezones = getTimezonesForCountry(country).map(t => t.name)
  }

  countryChanged(country: string) {
    console.debug('country changed', country)
    this.buildTimezoneList(country)
    this.countryForm.get('timezone').setValue(this.timezones[0])

    // the select floating label is not rendering properly after changing the value
    // see https://github.com/ionic-team/ionic-framework/issues/23809 (fixed in Ionic 6.0.15?)
    // this hack corrects the rendering, mentioned in above link
    setTimeout(() => {
      this.timezoneItem.el.classList.add('item-has-value')
    }, 50)
  }
}
